class VwPatolojiNumuneKabulDTO {
    id: number = 0;
    orderDetayId?: number = null;
    alinmaTarih?: string = null;
    dokuTemelOzellikId?: number = null;
    alinmaSekliId?: number = null;
    yerlesimYerId?: number = null;
    bulasiciVarMi?: string = "";
    acil?: string = "";
    talepAciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    materyalId?: number = null;
    materyalAdet?: number = null;
    klinikBilgi?: string = "";
    laboratuvarBilgi?: string = "";
    numunedurum?: number = null;
    fkTeslimedenpersonel?: number = null;
    muracaatId?: number = null;
    kimlikId?: number = null;
    hastaservisId?: number = null;
    organizasyonId?: number = null;
    servisId?: number = null;
    doktorId?: number = null;
    aciklama?: string = "";
    bagliOrganizasyonId?: number = null;
    doktorAdi?: string = "";
    servisAdi?: string = "";
    hastaAdiSoyadi?: string = "";
    yerlesimyeradi?: string = "";
    dokutemelozellikadi?: string = "";
    alinmasekiladi?: string = "";
    materyaladi?: string = "";
    rednedenadi?: string = "";
    teslimedenpersoneladsoyad?: string = "";
    teslimalanpersoneladsoyad?: string = "";
    protokolNo?: number = null;
    protokolOnek?: string = "";
    protokolYil?: number = null;
    protokolSira?: number = null;
    revizeno?: number = null;
    raportip?: number = null;
    orderId?: number = null;
    raporTipTanimid?: number = null;
    kabultarihsaat?: string = null;
    orderPatolojiId?: number = null;
    organizasyonAdi?: string = "";
    kurumId?: number = null;
    islemadi?: string = "";
    protokolGosterim?: string = "";
    rezervBarkodno?: number = null;
    icKurumBarkodNo?: string = "";
}
export default VwPatolojiNumuneKabulDTO;